import React from 'react';
import { Container, Card, ListGroup, Badge, Button } from 'react-bootstrap';
import { FaCalendarDay, FaExclamationCircle, FaCheck, FaRegBell } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../context/NotificationContext';
import AppNavbar from '../layout/Navbar';

const NotificationsPage = () => {
  const { notifications, totalCount, markAsRead, markAllAsRead } = useNotifications();
  const navigate = useNavigate();

  const handleNotificationClick = (notification) => {
    markAsRead(notification.id);
    navigate(`/client/${notification.client.id}`);
  };

  return (
    <>
      <AppNavbar />
      <Container className="mt-4">
        <Card className="client-detail-card">
          <Card.Header className="d-flex justify-content-between align-items-center bg-transparent border-bottom-0 pb-0">
            <h4 className="mb-0">
              <FaRegBell className="me-2 text-primary" /> Notifications
              {totalCount > 0 && (
                <Badge bg="danger" pill className="ms-2">
                  {totalCount}
                </Badge>
              )}
            </h4>
            {totalCount > 0 && (
              <Button 
                variant="outline-primary" 
                size="sm" 
                onClick={markAllAsRead}
                className="btn-glow"
              >
                <FaCheck className="me-1" /> Mark all as read
              </Button>
            )}
          </Card.Header>
          <Card.Body>
            {notifications.length === 0 ? (
              <div className="text-center py-5">
                <div className="mb-3">
                  <FaRegBell size={48} className="text-muted" />
                </div>
                <h5 className="text-muted">No new notifications</h5>
                <p className="text-muted">You're all caught up!</p>
              </div>
            ) : (
              <ListGroup variant="flush" className="notification-list">
                {notifications.map(notification => (
                  <ListGroup.Item 
                    key={notification.id}
                    action
                    onClick={() => handleNotificationClick(notification)}
                    className="notification-list-item d-flex align-items-start py-3"
                  >
                    <div className="notification-icon-wrapper me-3">
                      {notification.type === 'followup' ? (
                        <FaCalendarDay className="notification-type-icon followup" />
                      ) : (
                        <FaExclamationCircle className="notification-type-icon unseen" />
                      )}
                    </div>
                    <div className="notification-content">
                      <h6 className="notification-title mb-1">{notification.message}</h6>
                      <div className="notification-meta">
                        <small className="text-muted">
                          Client: {notification.client.firstName} {notification.client.lastName}
                        </small>
                        <small className="text-muted ms-3">
                          Phone: {notification.client.phone}
                        </small>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default NotificationsPage;
